import { DataService } from './DataService';
export class DummyDataService extends DataService {
  constructor(uid, dataType) {
    super(undefined);
    this.uid = uid;
    this._dataType = dataType;
  }
  get dataType() {
    return this._dataType;
  }
}